import { arrayMap } from "../../utils/array.utils";

export default function TableBody({ tbody = [], thead = [], action = <></> }) {
  const Action = action;
  return (
    <tbody>
      {arrayMap(tbody, (item, trIndex) => (
        <tr key={trIndex + 1}>
          {arrayMap([...thead], (td, tdIndex) => (
            <td style={{ ...(td === "Action" ? { width: "15%" } : {}) }} key={tdIndex + 1}>
              {td === "Action" ? <Action data={item} /> : item[td]}
            </td>
          ))}
        </tr>
      )) || (
        <tr>
          <td colSpan={[...thead].length} className="text-center">
            No data.
          </td>
        </tr>
      )}
    </tbody>
  );
}
